import { registerSettingsCard } from '../../components/SettingsCards';
import type { ModuleRoute } from '../types';
import { PermitPage } from './PermitPage';
import { PermitsPage } from './PermitsPage';
import { PermitTypesPage } from './PermitTypesPage';
import { LoneBoardPage } from './lone/BoardPage';
import { LoneReportPage } from './lone/ReportPage';
import { LoneWorkingSettingsCard } from './lone/SettingsCards';

registerSettingsCard('lone-working', LoneWorkingSettingsCard);

/** Pages of this area (permits to work, permit types, lone-working board, contacts and report). Owned by Phase 3 task W19; only that task edits files in this folder (W23 wires it last). */
export const routes: ModuleRoute[] = [
  { path: '/permits', element: <PermitsPage />, permission: 'permits.view' },
  { path: '/permits/types', element: <PermitTypesPage />, permission: 'permits.manage_types' },
  { path: '/permits/:id', element: <PermitPage />, permission: 'permits.view' },
  { path: '/lone-working', element: <LoneBoardPage />, permission: 'lone_working.view' },
  { path: '/lone-working/report', element: <LoneReportPage />, permission: 'lone_working.view' },
];
